import script from "./AnnouncementBodyFormatter.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementBodyFormatter.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementBodyFormatter.vue?vue&type=style&index=0&id=223cc26e&lang=scss"

export default script